import { styled } from '@mui/material/styles';
import { FilterAlt, FormatListBulleted, GridViewRounded } from "@mui/icons-material";
import { Button, Grid, Pagination, ToggleButton, ToggleButtonGroup, Typography } from "@mui/material";
import { Box, Stack } from "@mui/system";
import { useEffect, useState } from "react";
import BgBox from "../../../components/BgBox";
import { customAlert } from "../../../components/notify";
import ScrollBox from "../../../components/ScrollBox";
import { FaSortAmountDownAlt, FaSortAmountDown } from 'react-icons/fa';
import CustomDropDown from '../../../components/CustomDropDown';
import { useParams, useSearchParams } from 'react-router-dom';
import { useTranslation } from "react-i18next";

import QueryKey from '../../../QueryKey';
import { useQuery } from 'react-query';
import LoadingScreen from '../../../components/loadingScreen';
import MissingPage from '../../MissingPage';
import ShipmtCard from '../../../components/ShipmtCard';
import { getAllShipmts } from '../../../services/shipmt-service';
import ShipmtTable from '../../../components/ShipmtTable';
import { useAuthContext } from '../../../context/AuthContext';
import SearchTxtFieldClr from '../../../components/SearchTxtFieldClr';
import FilterMdl from './FilterMdl';
import { getLast30Days } from '../../../utils/format';
import { DEFAULT_PAGE_SIZE } from '../../../constants/pagination';
import RecordCount from "../../../components/RecordCount";

const StyledToggleButtonGroup = styled(ToggleButtonGroup)(({ theme }) => ({
  '& .MuiToggleButtonGroup-grouped': {
    // margin: theme.spacing(0.5),
    border: 0,
    '&.Mui-disabled': {
      border: 0,
    },
    '&:not(:first-of-type)': {
      borderRadius: theme.shape.borderRadius,
    },
    '&:first-of-type': {
      borderRadius: theme.shape.borderRadius,
    },
  },
}));

function ShipmentListPage() {
  const { t } = useTranslation();
  const { time } = useParams();
  const limit = DEFAULT_PAGE_SIZE
  const { setLastSeenObjFn } = useAuthContext();
  const ddArr = [
    { value: "invoice", label: t("bo.shipListPg.invoice") },
    { value: "ewb", label: t("bo.shipListPg.ewb") },
    { value: "shipmtId", label: t("bo.shipListPg.shpId") },
    { value: "status", label: t("bo.shipListPg.sts") },
    { value: "custName", label: t("bo.shipListPg.custName") },
    { value: "trkOpName", label: t("bo.shipListPg.opName") },
    { value: "custMobile", label: t("bo.shipListPg.custNum") },
    { value: "trkOpMobile", label: t("bo.shipListPg.opNum") },
    { value: "from", label: t("bo.shipListPg.from") },
    { value: "to", label: t("bo.shipListPg.to") },
    { value: "fromto", label: t("bo.shipListPg.fromTo") },
    { value: "loadType", label: t("bo.shipListPg.loadType") },
    { value: "matType", label: t("bo.shipListPg.mat") },
    { value: "trkNo", label: t("bo.shipListPg.trkNo") },
    { value: "reqId", label: t("bo.shipListPg.reqId") },
    { value: "cnor", label: t("bo.shipListPg.cnor") },
    { value: "cnee", label: t("bo.shipListPg.cnee") }
  ];

  // const [pageNumber, setPageNumber] = useState(1);
  // const [view, setView] = useState('list');
  // const [searchKeyWord, setSearchKeyWord] = useState("");
  // const [searchWord, setSearchWord] = useState("");
  // const [searchType, setSearchType] = useState(ddArr[0].value);
  // const [searchKeyType, setSearchKeyType] = useState(ddArr[0].value);
  // const [order, setOrder] = useState('desc');

  const [searchParams, setSearchParams] = useSearchParams();
  const pgNo = parseInt(searchParams.get("pgNo") || "1");
  const searchType = searchParams.get("st") || ddArr[0].value;
  const querySearchWord = searchParams.get("s") || "";
  const [searchWord, setSearchWord] = useState(querySearchWord || "");
  const [isSrchBtnClick, setIsSrchBtnClick] = useState(0);
  const order = searchParams.get("order") || "desc";
  const view = searchParams.get("view") || "list";

  const [searchKeyWord, setSearchKeyWord] = useState(searchWord);
  const [searchKeyType, setSearchKeyType] = useState(searchType);
  const [isFilterMdlOpen, setIsFilterMdlOpen] = useState(false);
  const { today, priorDate } = getLast30Days();
  const [filterObj, setFilterObj] = useState({
    fromDate: priorDate,
    toDate: today
  });

  function handleFilterObj(obj) {
    setSearchParams(prev => {
      prev.set("pgNo", 1)
      return prev
    }, { replace: true })
    setFilterObj({ ...obj })
  }

  async function fetchShipments() {
    // Normalize toDate to end-of-day so MySQL BETWEEN-style comparison against a
    // TIMESTAMP column includes rows created during the last day.
    const toDateArg = filterObj.toDate ? `${filterObj.toDate} 23:59:59` : undefined;
    const fromDateArg = filterObj.fromDate || undefined;

    return await getAllShipmts({
      pageNumber: pgNo,
      limit,
      searchKeyWord,
      searchType: searchKeyType,
      order,
      time,
      fromDate: fromDateArg,
      toDate: toDateArg,
      // On the "current" view, also surface completed shipments that still have
      // an outstanding balance. The backend JOINs truckop_request to decide.
      withBalance: time === 'current',
    });
  }

  const { isLoading, isError, error, data: shipmtRow } = useQuery(
    [QueryKey.shipmtList, pgNo, isSrchBtnClick, order, time, filterObj.fromDate, filterObj.toDate],
    fetchShipments, {
    keepPreviousData: true
  });

  function onViewChange(e, v) {
    if (v == null)
      return

    setSearchParams(prev => {
      prev.set("view", 1)
      return prev
    }, { replace: true })
  }

  async function onOrderChange(e, or) {
    if (or == null)
      return

    setSearchParams(prev => {
      prev.set("pgNo", 1)
      prev.set("order", or)
      return prev
    }, { replace: true })
  }


  const handlePageChange = async (event, value) => {
    setSearchParams(prev => {
      prev.set("pgNo", value)
      return prev
    }, { replace: true })
  };

  async function onSearchBtnClick(e) {
    setSearchKeyWord(searchWord.trim());
    setSearchKeyType(searchType);
    setIsSrchBtnClick((prevVal) => ++prevVal)
    setSearchParams(prev => {
      prev.set("pgNo", 1)
      return prev
    }, { replace: true })
  }

  function onSearch(e) {
    setSearchWord(e.target.value)
    setSearchParams(prev => {
      prev.set("s", e.target.value)
      return prev
    }, { replace: true })
  }

  function handleDDChange(e) {
    setSearchParams(prev => {
      prev.set("st", e.target.value)
      return prev
    }, { replace: true })
  }

  function handleOnClear(e) {
    setIsSrchBtnClick((prevVal) => ++prevVal)
    setSearchWord("");
    setSearchKeyWord("")
    setSearchParams(prev => {
      prev.set("pgNo", 1)
      prev.set("s", "")
      return prev
    }, { replace: true });
  }


  function getSrchTypeTxt() {
    let filteredObj = ddArr.filter((i) => i.value === searchType);
    return filteredObj[0]?.label || "";
  }

  useEffect(() => {
    if (time === "current") {
      setLastSeenObjFn('shipmt');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])



  if (isError) {
    customAlert(error);
    return <h2>Something went wrong</h2>
  }

  if (isLoading)
    return <Box sx={{ position: "absolute", top: 0, left: 0 }}><LoadingScreen /></Box>

  if (time !== "current" && time !== "history") {
    return <MissingPage />
  }

  return (

    <BgBox px={4} py={1}>
      <Stack direction={'row'} justifyContent="space-between" alignItems={"center"} mb={0.8} mt={0.5} px={2}>
        <Stack direction={'row'} alignItems={"center"}>
          <Typography variant='h5' sx={{ fontWeight: "bold", mr: 4 }}>{time === "current" ? t("bo.shipListPg.ship") : t("bo.shipListPg.shipHis")}<RecordCount count={shipmtRow?.totalLength} /></Typography>
          <StyledToggleButtonGroup color="primary" size="small" value={view} exclusive onChange={onViewChange} sx={{ mb: 0.5, height: 36 }}>
            <ToggleButton value='list'>
              <FormatListBulleted /> <Typography sx={{ ml: 0.3, fontSize: 15 }}>{t("bo.shipListPg.list")}</Typography>
            </ToggleButton>
            <ToggleButton value="grid">
              <GridViewRounded /> <Typography sx={{ ml: 0.3, fontSize: 15 }}>{t("bo.shipListPg.grid")}</Typography>
            </ToggleButton>
          </StyledToggleButtonGroup>
        </Stack>

        <Stack direction={'row'} justifyContent="space-between" alignItems={"center"}>
          <Box mb={0.5}><SearchTxtFieldClr handleOnClear={handleOnClear} variant={"outlined"} searchKeyWord={searchWord} onSearch={onSearch} onBtnClick={onSearchBtnClick} placeholder={`Search ${getSrchTypeTxt()} .....`} /></Box>
          <Button variant='outlined' sx={{ mx: 3, mb: 0.5, height: 36, }} startIcon={<FilterAlt />} onClick={() => setIsFilterMdlOpen(true)} >Filter</Button>
          <CustomDropDown height={36} width={140} handleDDChange={handleDDChange} ddArr={ddArr} defaultValue={searchType} />

          <StyledToggleButtonGroup color="primary" size="small" value={order} exclusive onChange={onOrderChange} sx={{ mb: 0.5, height: 36, mx: 3 }}>
            <ToggleButton value='desc'>
              <Stack sx={{ fontSize: 18, justifyContent: "center", alignItems: "center" }}>  <FaSortAmountDown /></Stack>
            </ToggleButton>
            <ToggleButton value="asc">
              <Stack sx={{ fontSize: 18, justifyContent: "center", alignItems: "center" }}>  <FaSortAmountDownAlt /></Stack>
            </ToggleButton>
          </StyledToggleButtonGroup>
        </Stack>
      </Stack>

      {view === 'list' ? <ShipmtTable shipmtRow={shipmtRow?.data} /> :
        <ScrollBox height={"84%"}>
          <Grid container spacing={1}
            direction="row"
            justifyContent="center"
            alignItems="center"
          >
            {shipmtRow?.data.map((i) => <Grid item xs="auto" key={i.id}> <ShipmtCard i={i} /> </Grid>)}
          </Grid>
        </ScrollBox>
      }

      <Stack sx={{ alignItems: "center", mt: 1 }}>
        <Pagination count={Math.ceil(shipmtRow?.totalLength / limit) || 0} color="primary" page={pgNo} onChange={handlePageChange} variant="outlined" shape="rounded" />
      </Stack>

      <FilterMdl modalOpen={isFilterMdlOpen} handleModalClose={() => setIsFilterMdlOpen(false)} filterObj={filterObj} handleFilterObj={handleFilterObj} />

    </BgBox>

  )
}

export default ShipmentListPage;